module.exports = __webpack_public_path__ + "static/media/JustAct_Logo_TM_V5-04.a0cd16a5.png";